<template>
    <v-dialog v-model="show" hide-overlay fullscreen transition="dialog-bottom-transition">
        <v-form ref="form" v-model="valid" :lazy-validation="lazy">
            <v-card>
                <v-toolbar color="yellow">
                    <v-btn icon @click="show = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Exámen Preocupacional / Periódico</v-toolbar-title>
                </v-toolbar>
                <v-card-text class="pt-2">
                    <v-row dense>
                        <v-col cols="4" sm="2" md="2">
                            <h6>Legajo: {{ legajo }}</h6>
                        </v-col>
                        <v-col cols="6" sm="6" md="6">
                            <h6>Nombre: {{ nombre }}</h6>
                        </v-col>
                        <v-col cols="4" sm="2" md="2">
                            <h6>Fecha Nacimiento: {{ fnacimiento }}</h6>
                        </v-col>
                        <!-- <v-col cols="4" sm="2" md="2">
                <h6>DNI: {{ dni }}</h6>
              </v-col> -->
                    </v-row>
                    <v-row dense>
                        <v-col cols="6" sm="2" md="2">
                            <v-text-field requiered :rules="requiredRules" label="Fecha" dense v-model="fecha">
                            </v-text-field>
                        </v-col>
                        <v-col cols="6" sm="3" md="3">
                            <v-select dense v-model="tipo" :items="listadotipo" label="Tipo" item-text="nombre"
                                item-value="codigo"></v-select>
                        </v-col>
                        <v-col cols="6" sm="3" md="3">
                            <v-select dense v-model="seguimiento" :items="listadoseg" label="Seguimiento" item-text="nombre"
                                item-value="codigo"></v-select>
                        </v-col>
                        <v-col cols="6" sm="2" md="2">
                            <v-text-field label="Días Seguimiento" dense v-model="dias">
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="12" sm="12" md="12">
                            <v-textarea label="Observaciones" rows="2" dense v-model="observ">
                            </v-textarea>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="12" sm="6" md="6">
                            <v-textarea label="Limitaciones" rows="2" dense v-model="limitaciones">
                            </v-textarea>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <v-textarea label="EPP" rows="2" dense v-model="epp">
                            </v-textarea>
                        </v-col>
                    </v-row>

                </v-card-text>
            </v-card>
            <v-card>
                <v-card-text>
                    <div>
                        <v-row dense>
                            <v-col cols="12" sm="6" md="6">
                                <v-file-input color="green darken-2" show-size label="Seleccionar Archivo" v-model="archivo"
                                    @change="selectFiles"></v-file-input>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="4" md="4">
                                <v-text-field color="green darken-2" v-model="titulo" prepend-icon="mdi-text" label="Título"
                                    maxlength="45" dense></v-text-field>
                            </v-col>
                        </v-row>
                    </div>
                </v-card-text>
            </v-card>
            <v-card color="green" dark tile>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="success" :disabled="!valid" @click.stop="guardarDatospersonal">Guardar</v-btn>

                    <v-btn color="error" @click.stop="show = false">Salir</v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>
  
<script>
import axios from "../../../src/axios-auth";
import moment from "moment";

export default {
    data: (vm) => ({
        requiredRules: [(v) => !!v || "Dato obligatorio"],
        legajo: "",
        dni: "",
        nombre: "",
        fnacimiento: "",
        fecha: moment().format("DD/MM/YYYY"),
        tipo: "",
        listadotipo: [{ nombre: "Anual", codigo: "A" },
        { nombre: "Seguimiento", codigo: "S" },],
        seguimiento: "",
        dias: "",
        listadoseg: [{ nombre: "NO", codigo: "NO" },
        { nombre: "SI", codigo: "SI" },],
        observ: "",
        limitaciones: "",
        epp: "",
        valid: false,
        deshabilitar: false,
        lazy: false,
        archivo: [],
        selectedFiles: undefined,
        progressInfos: [],
        message: "",
        titulo: "",
        fileInfos: [],
        validsubir: false,
    }),
    watch: {
        titulo(val) {
            if (this.titulo.length > 10) {
                this.validsubir = true;
            } else {
                this.validsubir = false;
            }
        },

    },
    computed: {
        show: {
            get() {
                this.buscarDatospersonal();
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.$refs.form.resetValidation();
                    this.vaciarModels();
                    this.$emit("close");
                }
            },
        },
    },
    props: ["visible", "leg", "id"],
    methods: {

        selectFiles(files) {
            this.selectedFiles = files;
        },


        buscarDatospersonal() {
            const leg = this.leg;
            const id = this.id;
            if (leg != null) {
                console.log("LEGAJO: " + leg);
                let self = this;
                axios
                    .get("/Medico/ListadoPersonal?", {
                        params: {
                            legajo: leg,
                            nombre: "",
                            grupo: "",
                            obrasocial: "",
                        },
                    })
                    .then((response) => {
                        console.log("HC " + response.data[0].legajo)
                        self.legajo = response.data[0].legajo;
                        self.nombre = response.data[0].nombre;
                        self.fnacimiento = moment(response.data[0].fnacimiento).format("DD/MM/YYYY");
                        self.codigo = response.data[0].codigo;
                    })
                    .catch((error) => {
                        //self.listadotrazabilidad = [];
                        console.log(error);
                    });
            }
        },
        vaciarModels() { },


        guardarDatospersonal() {
            this.$swal({
                title: "Guardar Exámen Periódico",
                text: "¿Desea guardar los datos del Exámen?",
                icon: "success",
                type: "success",
                showCancelButton: true,
                background: "#ececec",
                confirmButtonText: "Si",
                cancelButtonText: "No",
                showCloseButton: true,
                showLoaderOnConfirm: true,
            }).then((result) => {
                if (result.value) {

                    this.deshabilitar = true;
                    let self = this;
                    let formData = new FormData();
                    if (this.selectedFiles != null) {
                        formData.append("path", self.selectedFiles, self.selectedFiles.name);
                    }
                    formData.append("titulo", self.titulo)
                    formData.append("legajo", self.legajo)
                    formData.append("fecha", self.fecha)
                    formData.append("observ", self.observ)
                    formData.append("epp", self.epp)
                    formData.append("limitaciones", self.limitaciones)
                    formData.append("seguimiento", self.seguimiento)
                    formData.append("dias", self.dias)
                    formData.append("tipo", self.tipo)

                    axios
                        .post("Medico/GuardarExamen", formData, {
                            headers: {
                                "Content-Type": "multipart/form-data",
                            },
                        })
                        .then((response) => {
                            self.$refs.form.resetValidation();

                            self.showAlert({
                                icon: "success",
                                title: "Datos guardados con éxito",
                                vm: self,
                            });
                            self.vaciarModels();
                            self.$emit("close");
                        })
                        .catch({});
                } else {
                    //this.$swal('Cancelled', 'Your file is still intact', 'info')
                }
            });
        },
        showAlert(alertInfo) {
            alertInfo.vm.$swal.fire({
                icon: alertInfo.icon,
                title: alertInfo.title,
                showConfirmButton: false,
                background: "#ececec",
                timer: 2000,
            });
        },
    },
};
</script>
  